import { FormControl, InputLabel, MenuItem } from '@mui/material'
import Select, { SelectProps } from '@mui/material/Select'

export function SelectFieldLabel({
  options,
  value,
  onChange,
  label,
  ...props
}: SelectProps & {
  options: { label: string; value: number | string }[]
  label?: string
}) {
  return (
    <FormControl>
      <InputLabel id={`${label}-label`}>{label}</InputLabel>
      <Select
        labelId={`${label}-label`}
        id={`${label}-select`}
        value={value}
        label={label}
        onChange={onChange}
        {...props}
        sx={{
          height: 38,
          borderRadius: 3,
          width: '100%'
        }}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
